import { render } from "./BoosterHeader.vue?vue&type=template&id=6ccdba52&scoped=true&ts=true"
import script from "./BoosterHeader.vue?vue&type=script&lang=ts"
export * from "./BoosterHeader.vue?vue&type=script&lang=ts"

import "./BoosterHeader.vue?vue&type=style&index=0&id=6ccdba52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccdba52"]])

export default __exports__